import React from 'react';
import { Form, Input, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const NameField = ({ value, onChange, required = true, disabled = false, error, extra }) => {
    return (
        <Form.Item
            label={
                <span>
                    Name{' '}
                    <Tooltip title="Provide a friendly name for your destination cloud. This is for your reference within the RiverMeadow UI.">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
            validateStatus={error ? 'error' : ''}
            help={error}
            required={required}
            extra={extra}
        >
            <Input
                value={value || ''}
                onChange={onChange}
                disabled={disabled}
                placeholder="Enter Cloud Account Name (required)"
            />
        </Form.Item>
    );
};
